export default "__VITE_ASSET__Tlovz624__"